import { postRequest } from "./axios";

export type Cantiere = {

    idcantiere: number; 
    nomecantiere: string; 
    indrizzo: string; 
    cap: string; 
    localita: string; 
    provincia: string; 
    telefono: string; 
    fax: string; 
    referente: string; 
    recapitoreferente: string; 
        
}

export const getPresenzeCantieri = async () => {

    try {

        const result = await postRequest("/app/get_presenze_cantieri");

        return result; 

    } catch(e) {

        throw new Error("Impossibile ottenere la lista dei cantieri: " + e); 

    }

}

export const getPresenzeCantiere = async (idcantiere: string | null = "") => {

    try {

        const result = await postRequest("/app/get_presenze_cantiere/" + idcantiere);

        return result; 

    } catch(e) {

        throw new Error("Impossibile ottenere la lista dei cantieri: " + e); 

    }

}

export const getCantieri = async () => {

    try {

        const result = await postRequest("/cantieri/get_cantieri");

        return result; 

    } catch(e) {

        throw new Error("Impossibile ottenere la lista dei cantieri: " + e); 

    }

}